import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CreditCard from '../PaymentMode/Components/CreditCard/CreditCard';
import CreditCardSI from '../PaymentMode/Components/CreditCard/CreditCardSI';
import DebitCard from '../PaymentMode/Components/DebitCard/DebitCard';
import DebitCardSI from '../PaymentMode/Components/DebitCard/DebitCardSI';
import Netbanking from '../PaymentMode/Components/NetBanking/Netbanking';
import UpiDetails from '../PaymentMode/Components/UpiPayments/UpiDetails';
import UpiOtm from '../PaymentMode/Components/UpiPayments/UpiOtm';
import UpiDetailsEmandate from '../PaymentMode/Components/UpiPayments/UpiDetailsEmandate';
import EmiTabs from '../PaymentMode/Components/EmiCard/EmiTabs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBank, faCreditCard, faWallet } from '@fortawesome/free-solid-svg-icons';
import WalletPayment from '../PaymentMode/Components/WalletPayment/WalletPayment';
import Pos from '../PaymentMode/Components/POS/Pos';
import NcemiTabs from '../PaymentMode/Components/NcemiCard/NcemiTabs';
import LowCostEmiTabs from '../PaymentMode/Components/LowCostEmiCard/LowCostEmiTabs';
import NeftImps from '../PaymentMode/Components/NEFTIMPS/NeftImps';
import Skeleton from '@mui/material/Skeleton';
import AadharEmandate from '../PaymentMode/Components/AadharPayment/AadharEmandate';
import CreditCardRecurring from '../PaymentMode/Components/CreditCard/CreditCardRecurring';
import AadharRecurring from '../PaymentMode/Components/Aadhar/AadharRecurring';
import NetbankingRecurring from '../PaymentMode/Components/NetBanking/NetBankingRecurring';
import EmandateOnDebit from '../PaymentMode/Components/DebitCard/EmandateOnDebit';
import UpiDetailsRecurring from '../PaymentMode/Components/UpiPayments/UpiDetailsRecurring';
import ApplePay from '../PaymentMode/Components/ApplePay/ApplePay';
import { FaApplePay } from 'react-icons/fa';
import { isAppleDevice } from '../../Utility/deviceUtils';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function PaymnetTabs({ onCategoryValueChange }) {
  const [value, setValue] = useState(0);
  const [payModes, setPayModes] = useState([]);
  const [payModesToPass, setPayModesToPass] = useState([]);
  const [apiData, setApiData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isDisplayModeFive, setIsDisplayModeFive] = useState(false);
  const [eligibleModes, setEligibleModes] = useState([]);
  const [eligibleRecurringModes, setEligibleRecurringModes] = useState([]);
  const [categoryValue, setCategoryValue] = useState(0); 
  
  const isUpiModeAvailable = (data) =>
    !!data &&
    (data.isEligibleForUpiIntent ||
      data.isEligibleForIosPSPIntent ||
      data.isEligibleForUpiCollect ||
      data.showQrCodePayMode);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const queryParameters = new URLSearchParams(window.location.search);
        const order = queryParameters.get("orderNo");
        const var1 = queryParameters.get("var1");
        const var2 = queryParameters.get("var2");
        const temp = { orderNo: order };

        const response = await fetch(`/pay/securePayment/details/paymentModes?var1=${var1}&var2=${var2}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(temp),
        });

        const data = await response.json();
        setApiData(data);
        setIsLoading(false);
        const extractedPayModes = data.beans.payModes;
        const codeList = extractedPayModes.map((method) => method.code);
        setPayModes(codeList);
        setPayModesToPass(data.beans.payModes);
        setEligibleModes(data.eligibleModes);
	setEligibleRecurringModes(data.eligibleRecurringModes);
        if (data.displayMode === 5) {
        setIsDisplayModeFive(true);
      	} 
      	if(data.tabIndex === 1){
      	 setCategoryValue(1);
      	}
        console.log(extractedPayModes);
      } catch (error) {
        console.error('API request error:', error);
      }
    };

    if (!apiData) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (
      !apiData ||
      (eligibleModes.length === 0 && (!eligibleRecurringModes || eligibleRecurringModes.length === 0))
    ) {
      return;
    }

    const getFirstAvailableIndexForEligibleModes = () => {
      for (let i = 0; i < eligibleModes.length; i++) {
        const mode = eligibleModes[i];
        if (!mode) continue;

        if (mode.code === 'UPI') {
          const isUpiTabAvailable = isUpiModeAvailable(apiData);
          if (!isUpiTabAvailable) continue;
        }

        if (mode.code === 'UPI_EMANDATE') {
          const isUpiEmandateAvailableDisplayMode =
            apiData.showUpiEmandateIntent || apiData.showEmanQrCode || apiData.isEligibleForUpiCollectEman;
          if (!isUpiEmandateAvailableDisplayMode) continue;
        }

        return i;
      }
      return 0;
    };

    const getFirstAvailableIndexForEligibleRecurringModes = () => {
      if (!eligibleRecurringModes || eligibleRecurringModes.length === 0) {
        return 0;
      }

      for (let i = 0; i < eligibleRecurringModes.length; i++) {
        const mode = eligibleRecurringModes[i];
        if (!mode) continue;

        if (mode.code === 'UPI_EMANDATE') {
          const isUpiEmandateAvailableDisplayMode =
            apiData.showUpiEmandateIntent || apiData.showEmanQrCode || apiData.isEligibleForUpiCollectEman;
          if (!isUpiEmandateAvailableDisplayMode) continue;
        }

        return i;
      }

      return 0;
    };

    const getFirstAvailableIndexForCategory = () => {
      if (isDisplayModeFive) {
        return getFirstAvailableIndexForEligibleRecurringModes();
      }

      return getFirstAvailableIndexForEligibleModes();
    };

    const firstIndex = getFirstAvailableIndexForCategory();
    setValue(firstIndex);
  }, [eligibleModes, apiData, eligibleRecurringModes, isDisplayModeFive]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
    const handleCategoryChange = (event, newCategoryValue) => {
    setCategoryValue(newCategoryValue);

    if (!apiData) {
      setValue(0);
      return;
    }

    if (newCategoryValue === 0) {
      let firstIndex = 0;
      if (eligibleModes && eligibleModes.length > 0) {
        for (let i = 0; i < eligibleModes.length; i++) {
          const mode = eligibleModes[i];
          if (!mode) continue;

          if (mode.code === 'UPI') {
            const isUpiTabAvailable = isUpiModeAvailable(apiData);
            if (!isUpiTabAvailable) continue;
          }

          if (mode.code === 'UPI_EMANDATE') {
            const isUpiEmandateAvailableDisplayMode =
              apiData.showUpiEmandateIntent || apiData.showEmanQrCode || apiData.isEligibleForUpiCollectEman;
            if (!isUpiEmandateAvailableDisplayMode) continue;
          }

          firstIndex = i;
          break;
        }
      }
      setValue(firstIndex);
    } else {
      let firstIndex = 0;
      if (eligibleRecurringModes && eligibleRecurringModes.length > 0) {
        for (let i = 0; i < eligibleRecurringModes.length; i++) {
          const mode = eligibleRecurringModes[i];
          if (!mode) continue;

          if (mode.code === 'UPI_EMANDATE') {
            const isUpiEmandateAvailableDisplayMode =
              apiData.showUpiEmandateIntent || apiData.showEmanQrCode || apiData.isEligibleForUpiCollectEman;
            if (!isUpiEmandateAvailableDisplayMode) continue;
          }

          firstIndex = i;
          break;
        }
      }
      setValue(firstIndex);
    }
  };
   useEffect(() => {
    onCategoryValueChange(categoryValue); 
   }, [categoryValue]);

  const isApplePayDevice = isAppleDevice();
  const shouldShowApplePay = isApplePayDevice && apiData?.showApplePay !== false;
  const baseEligibleModes = shouldShowApplePay
    ? eligibleModes
    : eligibleModes.filter((mode) => mode.code !== 'APPLE_PAY');

  const applePayModeFromApi = shouldShowApplePay
    ? (apiData?.beans?.payModes || []).find(
        (mode) => mode && mode.code === 'APPLE_PAY' && mode.payModeToDisplay
      )
    : null;

  const hasApplePayInEligibleModes = baseEligibleModes.some((mode) => mode.code === 'APPLE_PAY');

  const oneTimeModes =
    !hasApplePayInEligibleModes && applePayModeFromApi
      ? [...baseEligibleModes, applePayModeFromApi]
      : baseEligibleModes;

  const isParentOtmSuccess =
    !!apiData &&
    (apiData.isParentOtmSuccess === true || apiData.beans?.isParentOtmSuccess === true);

  return (
    <>
    
    	
      {isLoading  ? (
        <div>
          <Skeleton animation="wave" className="md:block" height={600} variant="text" />
        </div>
      ) : (!isDisplayModeFive && <div className="hidden md:block">
          <Box sx={{ flexGrow: 1, display: 'flex', height: '100%' }}>
            <Tabs
              orientation="vertical"
              value={value}
              onChange={handleChange}
              aria-label="Vertical tabs example"
              sx={{ borderRight: 1, borderColor: 'divider' }}
              className="tabs-container left-sidebar"
            >
              {oneTimeModes.map((mode, index) => {
                switch (mode.code) {
                  case 'APPLE_PAY':
                    return (
                      <Tab
                        value={index}
                        className="tabs-left apple-pay"
                        label={
                          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                            <FaApplePay size={26} aria-hidden />
                            Apple Pay
                          </span>
                        }
                        {...a11yProps(index)}
                      />
                    );
                  case 'CC':
                    return <Tab value={index} className="tabs-left credit-card" label="Credit Card" {...a11yProps(index)} />;
                  case 'DC':
                    return <Tab value={index} className="tabs-left credit-card" label="Debit Card" {...a11yProps(index)} />;
                  case 'PPI':
                    return <Tab value={index} className="tabs-left wallet" label="Wallet" {...a11yProps(index)} />;
                  case 'SI_CC':
                    return <Tab value={index} className="tabs-left credit-card" label="Credit Card" {...a11yProps(index)} />;
                  case 'SI_DC':
                    return <Tab value={index} className="tabs-left credit-card" label="Debit Card" {...a11yProps(index)} />;
                  case 'NB':
                    return <Tab value={index} className="tabs-left net-banking" label="NetBanking" {...a11yProps(index)} />;
                  case 'UPI':
                    const isUpiTabAvailableMain = isUpiModeAvailable(apiData);
                    if (!isUpiTabAvailableMain) {
                      return null;
                    }
                    return <Tab value={index} className="tabs-left upi" label="UPI" {...a11yProps(index)} />;
                  case 'EMI':
                    return <Tab value={index} className="tabs-left easy-emi" label="EMI" {...a11yProps(index)} />;
                  case 'NCEMI':
                    return <Tab value={index} className="tabs-left easy-emi" label="Easy EMI" {...a11yProps(index)} />;
                  case 'lowCostEMI':
                    return <Tab value={index} className="tabs-left easy-emi" label="Low Cost EMI" {...a11yProps(index)} />;
                  case 'POS':
                    return <Tab value={index} className="tabs-left pos" label="POS" {...a11yProps(index)} />;
                  case 'SMARTCOLLECT':
                    return (
                      <Tab
                        value={index}
                        className="tabs-left pos"
                        label={
                          <span style={{ textAlign: 'left' }}>
                            NEFT/IMPS/RTGS <br />
                            <span style={{ fontSize: '11px' }}>(Pay Via Bank Account Transfer)</span>
                          </span>
                        }
                        {...a11yProps(index)}
                      />
                    );
                  case 'UPI_EMANDATE':
                    const isUpiEmandateAvailableDisplayMode = apiData.showUpiEmandateIntent || apiData.showEmanQrCode || apiData.isEligibleForUpiCollectEman;
                     if (!isUpiEmandateAvailableDisplayMode) {
                       return null;
                     }
                    return <Tab value={index} className="tabs-left upi" label="UPI Emandate" {...a11yProps(index)} />;
                  case 'UPI_OTM':
			const isUpiOtmAvailableDisplayMode = apiData.isEligibleForUpiOTMIntent || apiData.isEligibleForUpiOTMQR || apiData.isEligibleForUpiOTMCollect;
	                     if (!isUpiOtmAvailableDisplayMode) {
        	               return null;
	                     }
	            return (
                      <Tab
                        value={index}
                        className="tabs-left upi"
                        label={
                          <span style={{ textAlign: 'left' }}>
                            Block payment <br />
                            <span style={{ fontSize: '11px' }}>via B-ASBA</span>
                          </span>
                        }
                        {...a11yProps(index)}
                      />
                    );

                  default:
                    return null;
                }
              })}
            </Tabs>
            {oneTimeModes.map((mode, index) => {
              switch (mode.code) {
                case 'APPLE_PAY':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <ApplePay apiData={apiData} />
                    </TabPanel>
                  );
                case 'CC':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <CreditCard secret={apiData.secret} cardDownBanks={apiData.cardDownBanks} />
                    </TabPanel>
                  );
                case 'DC':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <DebitCard secret={apiData.secret} cardDownBanks={apiData.cardDownBanks} />
                    </TabPanel>
                  );
                case 'PPI':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <WalletPayment payModesToPass={payModesToPass} displayOrderNo={apiData.displayOrderNo} rzpWalletTextChangeToHide={apiData.rzpWalletTextChangeToHide} rzpWalletPartnerCode={apiData.rzpWalletPartnerCode} />
                    </TabPanel>
                  );
                case 'SI_CC':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <CreditCardSI
                        secret={apiData.secret}
                        cardDownBanks={apiData.cardDownBanks}
                        displayMode={apiData.displayMode}
                        displayModeCheck={apiData.displayModeCheck}
                      />
                    </TabPanel>
                  );
                case 'SI_DC':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <DebitCardSI
                        secret={apiData.secret}
                        cardDownBanks={apiData.cardDownBanks}
                        displayMode={apiData.displayMode}
                        displayModeCheck={apiData.displayModeCheck}
                      />
                    </TabPanel>
                  );
                case 'NB':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <Netbanking payModesToPass={payModesToPass} nbDownBanks={apiData.nbDownBanks} />
                    </TabPanel>
                  );
                case 'UPI':
                  const isUpiPanelAvailableMain = isUpiModeAvailable(apiData);
                  if (!isUpiPanelAvailableMain) {
                    return null;
                  }
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <UpiDetails payModesToPass={apiData} />
                    </TabPanel>
                  );
                case 'EMI':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <div className="debit-card-tabs">
                        <EmiTabs apiData={apiData} />
                      </div>
                    </TabPanel>
                  );
                case 'NCEMI':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <div className="debit-card-tabs">
                        <NcemiTabs apiData={apiData} />
                      </div>
                    </TabPanel>
                  );
                case 'lowCostEMI':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <div className="debit-card-tabs">
                        <LowCostEmiTabs apiData={apiData} />
                      </div>
                    </TabPanel>
                  );
                case 'POS':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <div className="debit-card-tabs">
                        <Pos />
                      </div>
                    </TabPanel>
                  );
                case 'SMARTCOLLECT':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <NeftImps payModesToPass={apiData} />
                    </TabPanel>
                  );
                case 'UPI_EMANDATE':
                  const isUpiEmandateAvailableDisplayMode = apiData.showUpiEmandateIntent || apiData.showEmanQrCode || apiData.isEligibleForUpiCollectEman;
                     if (!isUpiEmandateAvailableDisplayMode) {
                       return null;
                     }
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <UpiDetailsEmandate
                        payMode={apiData.eligibleModes[index]}
                        productId={apiData.productId}
                        txAmount={apiData.amount}
                        showEmanQrCode={apiData.showEmanQrCode}
                        showUpiEmandateIntent={apiData.showUpiEmandateIntent}
                        isEligibleForUpiCollectEman={apiData.isEligibleForUpiCollectEman}
                      />
                    </TabPanel>
                  );
                case 'UPI_OTM':
		   const isUpiOtmAvailableDisplayMode = apiData.isEligibleForUpiOTMIntent || apiData.isEligibleForUpiOTMQR || apiData.isEligibleForUpiOTMCollect;
                     if (!isUpiOtmAvailableDisplayMode) {
                       return null;
                     }

                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <UpiOtm payModesToPass={apiData} />
                    </TabPanel>
                  );
               
                default:
                  return null;
              }
            })}
          </Box>
        </div>
      )}
      {isLoading ? (
        <Skeleton animation="wave" className="md:block" height={600} variant="text" />
      ) : (isDisplayModeFive && <div className="hidden md:block">
          <Box className="mode-five" sx={{flexDirection: 'column', height: '100%' }}>
            {/* Category Selector Tabs */}
            <Tabs
              value={categoryValue}
              onChange={handleCategoryChange}
              aria-label="Payment Mode Categories"
              variant="fullWidth"
                sx={{
      '& .MuiTabs-flexContainer': {
        justifyContent: 'center', // Center the tabs in the container
      }
    }}
             >
              <Tab className="mode-five-tab-btn" label="One Time Payment" {...a11yProps(0)} />
              <Tab className="mode-five-tab-btn" label="Recurring Payment" {...a11yProps(1)} />
            </Tabs>

            {/* Payment Modes Tabs */}
            <Box sx={{ display: 'flex', height: '100%' }}>
              <Tabs
                orientation="vertical"
                value={value}
                onChange={handleChange}
                aria-label="Payment Modes"
                sx={{ borderRight: 1, borderColor: 'divider' }}
                className="tabs-container left-sidebar"
              >
               {categoryValue === 0 && oneTimeModes.map((mode, index) => {
                switch (mode.code) {
                  case 'APPLE_PAY':
                    return (
                      <Tab
                        value={index}
                        className="tabs-left apple-pay"
                        label={
                          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                            <FaApplePay size={22} aria-hidden />
                            Apple Pay
                          </span>
                        }
                        {...a11yProps(index)}
                      />
                    );
                  case 'CC':
                    return <Tab value={index} className="tabs-left credit-card" label="Credit Card" {...a11yProps(index)} />;
                  case 'DC':
                    return <Tab value={index} className="tabs-left credit-card" label="Debit Card" {...a11yProps(index)} />;
                  case 'PPI':
                    return <Tab value={index} className="tabs-left wallet" label="Wallet" {...a11yProps(index)} />;
                  case 'NB':
                    return <Tab value={index} className="tabs-left net-banking" label="Netbanking" {...a11yProps(index)} />;
                  case 'UPI':
                    const isUpiTabAvailable = isUpiModeAvailable(apiData);
                    if (!isUpiTabAvailable) {
                      return null;
                    }
                    return <Tab value={index} className="tabs-left upi" label="UPI" {...a11yProps(index)} />;
                  case 'EMI':
                    return <Tab value={index} className="tabs-left easy-emi" label="EMI" {...a11yProps(index)} />;
                  case 'NCEMI':
                    return <Tab value={index} className="tabs-left easy-emi" label="Easy EMI" {...a11yProps(index)} />;
                  case 'lowCostEMI':
                    return <Tab value={index} className="tabs-left easy-emi" label="Low Cost EMI" {...a11yProps(index)} />;
                  case 'POS':
                    return <Tab value={index} className="tabs-left pos" label="POS" {...a11yProps(index)} />;
                  case 'SMARTCOLLECT':
                    return (
                      <Tab
                        value={index}
                        className="tabs-left pos"
                        label={
                          <span style={{ textAlign: 'left' }}>
                            NEFT/IMPS/RTGS <br />
                            <span style={{ fontSize: '11px' }}>(Pay Via Bank Account Transfer)</span>
                          </span>
                        }
                        {...a11yProps(index)}
                      />
                    );
                  default:
                    return null;
                }
              })}
              {categoryValue === 1 && eligibleRecurringModes.map((mode, index) => {
               switch(mode.code){
              case 'SI_CC':
                return ( <Tab value={index} className="tabs-left credit-card" label="Credit Card" {...a11yProps(index)} />);
              case 'EMANDATE_NB':
                 return ( <Tab value={index} className="tabs-left net-banking" label="Netbanking" {...a11yProps(index)} />);
              case 'EMANDATE_ADHR':
                 return ( <Tab value={index} className="tabs-left pos" label="Aadhar Card" {...a11yProps(index)} />);
                break;
              case 'RECURRING_DC':
                 return ( <Tab value={index} className="tabs-left credit-card" label="Debit Card" {...a11yProps(index)} />);
                break;
              case 'UPI_EMANDATE':
                const isUpiEmandateAvailableDisplayMode = apiData.showUpiEmandateIntent || apiData.showEmanQrCode || apiData.isEligibleForUpiCollectEman;
                     if (!isUpiEmandateAvailableDisplayMode) {
                       return null;
                     }
                return (<Tab value={index} className="tabs-left upi" label="UPI Emandate" {...a11yProps(index)} />);
                break;
              default:
                break;
            }
              })}
              </Tabs>
		{categoryValue === 0 && oneTimeModes.map((mode, index) => {
              switch (mode.code) {
                case 'APPLE_PAY':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <ApplePay apiData={apiData} />
                    </TabPanel>
                  );
                case 'CC':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <CreditCard secret={apiData.secret} cardDownBanks={apiData.cardDownBanks} />
                    </TabPanel>
                  );
                case 'DC':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <DebitCard secret={apiData.secret} cardDownBanks={apiData.cardDownBanks} />
                    </TabPanel>
                  );
                case 'PPI':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <WalletPayment payModesToPass={payModesToPass} displayOrderNo={apiData.displayOrderNo} rzpWalletTextChangeToHide={apiData.rzpWalletTextChangeToHide} rzpWalletPartnerCode={apiData.rzpWalletPartnerCode} />
                    </TabPanel>
                  );
                 case 'NB':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <Netbanking payModesToPass={payModesToPass} nbDownBanks={apiData.nbDownBanks} />
                    </TabPanel>
                  );
                case 'UPI':
                  const isUpiPanelAvailable = isUpiModeAvailable(apiData);
                  if (!isUpiPanelAvailable) {
                    return null;
                  }
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <UpiDetails payModesToPass={apiData} />
                    </TabPanel>
                  );
                case 'EMI':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <div className="debit-card-tabs">
                        <EmiTabs apiData={apiData} />
                      </div>
                    </TabPanel>
                  );
                case 'NCEMI':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <div className="debit-card-tabs">
                        <NcemiTabs apiData={apiData} />
                      </div>
                    </TabPanel>
                  );
                case 'lowCostEMI':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <div className="debit-card-tabs">
                        <LowCostEmiTabs apiData={apiData} />
                      </div>
                    </TabPanel>
                  );
                case 'POS':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <div className="debit-card-tabs">
                        <Pos />
                      </div>
                    </TabPanel>
                  );
                case 'SMARTCOLLECT':
                  return (
                    <TabPanel className="tabs" value={value} index={index}>
                      <NeftImps payModesToPass={apiData} />
                    </TabPanel>
                  );
                default:
                  return null;
              }
            })}
            
            {categoryValue === 1 && eligibleRecurringModes.map((mode, index) => {
        switch(mode.code){
              case 'SI_CC':
                return (<TabPanel className="tabs" value={value} index={index}>
                          <CreditCardRecurring  secret={apiData.secret} cardDownBanks = {apiData.cardDownBanks}
                            productId = {apiData.productId} srcSupplierId = {apiData.srcSupplierId} displayMode = {apiData.displayMode}
                            isParentOtmSuccess={isParentOtmSuccess} />
                        </TabPanel>);
                break;
              case 'EMANDATE_NB':
                return (<TabPanel className="tabs" value={value} index={index}>
                  <NetbankingRecurring payModesToPass={payModesToPass} displayOrderNo={apiData.encryptParentOrderNo} eMandateNo={apiData.eMandateNo}
                                      maxAmountLimit={apiData.maxAmountLimit} parentOrderNo={apiData.parentOrderNo} order_id={apiData.order_id} cust_id={apiData.cust_id} mid={apiData.mid}
                                     expire_at={apiData.expire_at} orderNo={apiData.encryptParentOrderNo} productId = {apiData.productId}
                                     isParentOtmSuccess={isParentOtmSuccess} />
                </TabPanel>);
                break;
               case 'EMANDATE_ADHR':
                  return (<TabPanel className="tabs" value={value} index={index}>
                            <AadharRecurring payModesToPass={payModesToPass} displayOrderNo={apiData.encryptParentOrderNo} eMandateNo={apiData.eMandateNo}
                               maxAmountLimit={apiData.maxAmountLimit} parentOrderNo={apiData.parentOrderNo} order_id={apiData.order_id} cust_id={apiData.cust_id} mid={apiData.mid}
                               expire_at={apiData.expire_at} orderNo={apiData.encryptParentOrderNo} productId = {apiData.productId}
                               isParentOtmSuccess={isParentOtmSuccess} />
                          </TabPanel>);
                  break;
             case 'RECURRING_DC':
                  return (<TabPanel className="tabs" value={value} index={index}>
                             <EmandateOnDebit payModesToPass={payModesToPass} displayOrderNo={apiData.displayOrderNo} eMandateNo={apiData.eMandateNo}
                                 maxAmountLimit={apiData.maxAmountLimit} parentOrderNo={apiData.parentOrderNo} order_id={apiData.order_id} cust_id={apiData.cust_id} mid={apiData.mid}
                                 expire_at={apiData.expire_at} sidcBankNote={apiData.sidcBankNote} secret={apiData.secret} cardDownBanks = {apiData.cardDownBanks}
                                 productId = {apiData.productId} srcSupplierId = {apiData.srcSupplierId} displayMode = {apiData.displayMode} orderNo={apiData.orderNo}
                                 isParentOtmSuccess={isParentOtmSuccess} />
                          </TabPanel>);
              case 'UPI_EMANDATE':
                const isUpiEmandateAvailableDisplayMode = apiData.showUpiEmandateIntent || apiData.showEmanQrCode || apiData.isEligibleForUpiCollectEman;
                     if (!isUpiEmandateAvailableDisplayMode) {
                       return null;
                     }
                return (<TabPanel className="tabs" value={value} index={index}>
                          <UpiDetailsEmandate
                            payMode={apiData.eligibleRecurringModes[index]}
                            productId={apiData.productId}
                            txAmount={apiData.amount}
                            showEmanQrCode={apiData.showEmanQrCode}
                            showUpiEmandateIntent={apiData.showUpiEmandateIntent}
                            isEligibleForUpiCollectEman={apiData.isEligibleForUpiCollectEman}
                          />
                        </TabPanel>); 
              default:
                break; 
            }
          })}
          </Box>
          </Box>
        </div>
      )}
   
      
      
    </>
  );
}

